'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function resizeWindow() {
	$('.top-content').css('max-height', $(window).height());
	// if($(window).width() >= 1500) {
	// 	$('.header').css('margin-left','-750px');
	// } else {
	// 	$('.header').css('margin-left','-'+$(window).width()/2+'px');
	// }
}

function _get_form_token() {
	$.get(site_url + '/ajax/functions.php?operation=_get_form_token', function (resp) {
		$("input[name=_token][type=hidden]").each(function () {
			this.value = resp;
		});
	});
}

$(document).ready(function () {

	_get_form_token();

	$('.btn-book').click(function () {
		$(this).siblings('.rezy-btn').find('span').trigger('click');
	});

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	// if($('#home').length > 0) {
	// 	var headerPos = $('header').position().top + $('header').height() ;
	// }

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		var top = $(document).scrollTop();
		// if($('#home').length > 0) {
		//     if(top >= headerPos) {
		// 	    $('header').addClass('fixed');
		// 	    showMenu();
		// 	} else {
		// 	    $('header').removeClass('fixed');
		//     	hideMenu();
		// 	}
		// }
	});
	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $('.top-content').height() }, 800, 'easeOutExpo');
	});
	$('.burger').click(function () {
		if ($('header').hasClass("open")) {
			hideMenu();
		} else {
			showMenu();
		}
	});

	$('.easy-scroll').click(function () {
		var target = $(this).attr("href");
		if ($('body.main').length > 0) {
			var padding = 0;
		} else {
			var padding = $('header').height() * 2;
		}
		$('html, body').animate({ scrollTop: $(target).offset().top - padding }, 1000);
		return false;
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	$('.tabs li a').click(function () {

		$('.tabs li').removeClass('active');
		$(this).parent("li").addClass('active');
		var tab = $(this).attr('href');

		$('.tab-content').fadeOut(function () {
			setTimeout(function () {
				$(tab).fadeIn();
			}, 100);
		});

		return false;
	});
	//$('#accommodations li').addClass('animate-fade top');
	$('input,textarea').on("focus", function () {
		var input = $(this);
		// assuming label is the parent, i.e. <label><input /></label>
		var label = $(this).parent();
		label.addClass('focussed');
		input.on("blur", function () {
			label.removeClass('focussed');
			input.off("blur");
		});
	});
	$('textarea').parent('div').addClass('text-field');
	$('select').parent('div').addClass('text-select');
	$('datepicker').attr('placeholder', ' ');
	$('input,textarea').change(function () {
		if ($(this).val() != '') {
			$(this).parent().addClass('filled');
		} else {
			$(this).parent().removeClass('filled');
		}
	});
	if (window.location.hash) {
		setTimeout(function () {
			$('html, body').animate({ scrollTop: $(window.location.hash).offset().top - $('header').height() }, 800);
		}, 500);
	}

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
	});

	//FANCYBOX
	$('.fancybox-copy').fancybox({
		wrapCSS: 'fancybox-copy-holder',
		maxWidth: 800
	});

	$('.expand-content').click(function () {
		event.preventDefault();
		$(this).next().slideDown();
	});

	$('.closemore').click(function () {
		event.preventDefault();
		$(this).parent().slideUp();
	});
	$('.toggle-tab').click(function (e) {
		e.preventDefault();
		var targetTab = $(this).attr('href');
		$(targetTab).slideToggle();
	});
	$('.close-tab').click(function (e) {
		e.preventDefault();
		$(this).closest('.notice-tab').slideToggle();
	});

	$('.swap-link').on('change', function () {
		$(this).next().attr('href', $(this).val());
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	// VideoJS Object for home page video widget
	if ($('body#home').length > 0) {
		var homePageVideoPlayer = function homePageVideoPlayer(ele) {
			if ((typeof ele === 'undefined' ? 'undefined' : _typeof(ele)) === undefined || !videojs) {
				return false;
			}

			var _this = this;
			this.player = videojs(ele);
			this.player.ready(function () {
				var player = this;
				$(".right-side.video-wrapper").on('click', function () {
					if (!player.paused()) {
						player.pause();
						_this.updateVideoState('pause');
					} else {
						player.play();
						_this.updateVideoState('play');
					}
				});
			});

			this.player.on('ended', function () {
				_this.updateVideoState('pause');
			});

			this.updateVideoState = function (state) {
				switch (state) {
					case 'play':
						$(".video-placeholder, .copy.paused").hide();
						$(".copy.playing").show();
						break;
					case 'pause':
						$(".copy.playing").hide();
						$(".video-placeholder, .copy.paused").show();
						break;
				}
			};
		};
	}

	//Remove Attributes
	$('#third-nav').removeAttr('aria-labelledby');

	// init player
	if ($('body#home').length > 0) {
		var player = new homePageVideoPlayer("home-page-video");
	}
});

$(window).on('load', function () {
	//Slick Slider
	$('.sym-slides').slick();
	equalize();
});

function showMenu() {
	$('.header').addClass('open');
	/*
 	$('#primary-nav').animate({left:'170px'},{queue:false,duration:600});
 	setTimeout(function() {
 		$('#primary-nav li a').css('opacity',1);
 	}, 1000);
 */
}

function hideMenu() {
	$('.header').removeClass('open');
	/*
 	$('#primary-nav li a').css('opacity',0);
 	$('#primary-nav').animate({left:'100%'},{queue:false,duration:600});
 */
}